import { FC } from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { TPagination } from "@/types/api";
import { DEFAULT_PER_PAGE, START_PAGE } from "@/constants/pagination";
import { DebounceInput } from "@/components/elements/Input/Input";
import { Button } from "@/components/elements/Button";

type Props = {
  pagination?: TPagination;
  keyword: string;
  onChangeKeyword: (value: string) => void;
  onSubmit: () => void;
  onClear: () => void;
};

export const ReportListTop: FC<Props> = ({ pagination, keyword, onChangeKeyword, onSubmit, onClear }) => {
  const total = pagination?.total ?? 0;
  const page = pagination?.page ?? START_PAGE;
  const perPage = pagination?.perPage ?? DEFAULT_PER_PAGE;

  const isEmpty = !keyword.trim();

  return (
    <>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} md>
          <Stack spacing={1}>
            <Typography variant="cap12Light">管理番号または所属機関名から検索</Typography>
            <DebounceInput
              placeholder="入力してください"
              value={keyword}
              onChange={(e) => onChangeKeyword(e.target.value)}
              size="md"
              style={{ width: "100%" }}
            />
          </Stack>
        </Grid>

        <Grid item xs="auto">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Button type="button" variant="text" disabled={isEmpty} onClick={onClear}>
              <Typography variant="body14Semi">クリア</Typography>
            </Button>
            <Button type="button" variant="outline" disabled={isEmpty} onClick={onSubmit}>
              <Typography variant="body14Semi">検索</Typography>
            </Button>
          </Stack>
        </Grid>
      </Grid>

      <Typography variant="body14Semi">
        全 {total.toLocaleString()} 件中 {Math.min(page * perPage, total)} 件を表示
      </Typography>
    </>
  );
};
